import React, { useState } from "react";
import {
  makeStyles,
  Grid,
  Box,
  Tabs,
  Tab,
  Paper,
  Container,
  Button,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import { animated } from "react-spring";
import Notice from "./NoticeList/Notice";
import NoticeList from "./NoticeList";
import { Link } from "react-router-dom";
import ScheduleList from "./ScheduleList";

const useStyles = makeStyles((theme) => ({
  bgStyle: {
    "&:hover": {
      // background: "rgba(0,0,0,.05)",
    },
  },
  imgBg: {
    backgroundImage:
      // "url(https://images.unsplash.com/photo-1524222717473-730000096953?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjExNzczfQ&s=8b1938d0d4ef26e336db84568708980a)",
      // "url(images/main/airdryer/adsorption_air_dryer/heater_type.png)",
      "url(images/main/airdryer/refri.jpg)",

    position: "absolute",
    zIndex: -2,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "var(--border-radius-primary)",
    // padding: "40px 38px 45px",
    background: "no-repeat center center",
    // backgroundSize: "50%",
    backgroundSize: "cover",
    "&::before": {
      display: "block",
      width: "100%",
      height: "100%",
      content: '" "',
      opacity: ".4",
      backgroundImage: " linear-gradient(234deg,#394245,#000)",
    },
    // border: "1px solid",
    willChange: "transform",
  },
  objBg: {
    // backgroundImage:
    //   "url(images/main/airdryer/adsorption_air_dryer/heater_type.png)",
    position: "absolute",
    zIndex: -1,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "var(--border-radius-primary)",
    // padding: "40px 38px 45px",
    background: "no-repeat 93% 50%",
    backgroundSize: "60%",
    filter: "brightness(0.4)",
    // "&::before": {
    //   display: "block",
    //   width: "100%",
    //   height: "100%",
    //   content: '" "',
    //   opacity: ".4",
    //   backgroundImage: " linear-gradient(234deg,#394245,#000)",
    // },
    // border: "1px solid",
    willChange: "transform",
  },
  txtStyle: {
    // color: "black",
    color: "white",
    fontWeight: "bold",
    fontFamily: "Noto Sans KR",
  },
  subTitleStyle: {
    // color: "black",
    color: "#e77842",
    fontFamily: "Noto Sans KR",
    lineHeight: 1.6,
    fontSize: 19,
    fontWeight: 700,
    letterSpacing: "0.15px",
  },
  subtxtStyle: {
    // color: "black",
    color: "white",
    fontFamily: "Noto Sans KR",
    fontWeight: 500,
    fontSize: 16,
  },
  bigIndicator: { backgroundColor: "rgb(188, 36, 60)" },
  tabRoot: {
    minWidth: 88,
  },
  noticeContainer: {
    paddingLeft: 48,
    paddingRight: 48,
    paddingTop: 12,
    [theme.breakpoints.down("md")]: {
      paddingLeft: 24,
      paddingRight: 24,
      paddingTop: 12,
    },
  },
}));

interface TwoThirdNoticeProps {
  // children: React.ReactNode | null | string | undefined;
  match: any;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Container>
            <Box>{children}</Box>
          </Container>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TwoThirdNotice({ match }: TwoThirdNoticeProps) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  // const [{ sValue, brightValue, opacityValue, colorValue }, set] = useSpring(
  //   () => ({
  //     sValue: 1,
  //     brightValue: 0.4,
  //     opacityValue: 1,
  //     colorValue: "#e77842",
  //   })
  // );

  const [value, setValue] = useState(0);
  const [state, setState] = useState(0);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const handleNoticeClick = (
    // event: React.ChangeEvent<{}>,
    newValue: number
  ) => {
    setState(newValue);
  };

  return (
    <Grid
      xs={!matches ? 8 : 12}
      lg={8}
      item
      container
      style={{ height: 200 }}
      justify={"center"}
    >
      <Paper
        elevation={0}
        component={animated.article}
        style={{
          background: `${
            state == 0
              ? "linear-gradient( 307.97deg, #ffffff 16.02%, rgba(255,255,255,0) 59.08% ), #fff5f5"
              : "linear-gradient( 311.77deg, #ffffff 21%, rgba(255,255,255,0) 58.34% ), #e6fffa"
          }`,
          width: "100%",
          zIndex: 0,
          overflow: "hidden",
          position: "relative",

          willChange: "transform",
          minHeight: !matches ? 260 : 193,
          maxHeight: !matches ? 260 : 193,
          // padding: "1rem 2rem 2rem 2rem",
          // backgroundImage:
          //   "linear-gradient(45deg,var(--gradient-orange-start),var(--gradient-orange-end))",
          borderRadius: 40,
          // border: "1px solid #bc243c38",
          // margin: "15px 0 15px 15px",
          margin: 15,
          boxSizing: "border-box",
          // transform: sValue.interpolate((sValue) => `scale(${sValue}`),
        }}
        // onMouseEnter={() =>
        //   set({ sValue: 1.03, brightValue: 1, opacityValue: 0 })
        // }
        // onMouseLeave={() =>
        //   set({ sValue: 1, brightValue: 0.4, opacityValue: 1 })
        // }
      >
        <Grid
          xs={12}
          item
          container
          justify="center"
          alignItems={"center"}
          // style={{ height: "15%", }}
        >
          <Grid
            item
            xs={12}
            container
            style={{
              paddingLeft: !matches ? 32 : 8,
              fontFamily: "Noto Sans Kr",
              fontWeight: 700,
              fontSize: 23,
              paddingTop: 8,
              paddingBottom: 8,
              // borderBottom: "1px solid #dadce0",
              borderBottom: `${
                state == 0 ? "1px solid #bc243c38" : "1px solid #2c7a7b40"
              }`,
            }}
          >
            <Grid xs={!matches ? 10 : 9} item container>
              <Grid>
                <Button
                  onClick={() => {
                    setState(0);
                  }}
                  style={{
                    color: `${state == 0 ? "#bc243c" : "#00000099"}`,
                    fontSize: 16,
                    padding: 0,
                    fontFamily: "Noto Sans Kr",
                    // backgroundColor: "#805AD5",
                    fontWeight: 700,
                  }}
                >
                  공지
                </Button>
              </Grid>
              <Grid style={{}}>
                <Button
                  onClick={() => {
                    setState(1);
                  }}
                  style={{
                    color: `${state == 0 ? "#00000099" : "#2C7A7B"}`,

                    padding: 0,
                    fontSize: 16,
                    fontFamily: "Noto Sans Kr",
                    // backgroundColor: "#805AD5",
                    fontWeight: 700,
                  }}
                >
                  일정
                </Button>
              </Grid>
            </Grid>
            {state == 0 ? (
              <Grid xs={!matches ? 2 : 3} item>
                <Link
                  to={`/notice/`}
                  style={{
                    // textAlign:"right",
                    fontFamily: "Noto Sans Kr",
                    fontWeight: 600,
                    fontSize: 12,
                    color: "rgba(0, 0, 0, 0.6)",
                  }}
                >
                  공지 더보기
                </Link>
              </Grid>
            ) : (
              <Grid xs={!matches ? 2 : 3} item>
                <Link
                  to={`/schedule/`}
                  style={{
                    // textAlign:"right",
                    fontFamily: "Noto Sans Kr",
                    fontWeight: 600,
                    fontSize: 12,
                    color: "rgba(0, 0, 0, 0.6)",
                  }}
                >
                  일정 더보기
                </Link>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid
          xs={12}
          item
          container
          component={"ul"}
          alignItems="center"
          className={classes.noticeContainer}
          // style={{ paddingLeft: 48, paddingRight: 48, paddingTop: 12 }}
        >
          {state == 0 ? <NoticeList match={match} /> : <ScheduleList />}
        </Grid>
        {/* <Tabs
          value={value}
          onChange={handleChange}
          // aria-label="simple tabs example"
          // centered
          style={{ borderBottom: "1px solid #dadce0" }}
          classes={{
            indicator: classes.bigIndicator,
          }}
        >
          <Tab
            label="공지"
            {...a11yProps(0)}
            disableRipple
            style={{
              fontFamily: "Noto Sans KR",
              fontSize: 20,
              fontWeight: 700,
            }}
            classes={{ root: classes.tabRoot }}
          >
           
          </Tab>
          <Tab
            label="일정"
            {...a11yProps(1)}
            disableRipple
            style={{
              fontFamily: "Noto Sans KR",
              fontSize: 20,
              fontWeight: 700,
            }}
          />
        </Tabs>

        <TabPanel value={value} index={0}>
          <Grid
            xs={12}
            item
            container
            component={"ul"}
            style={{ paddingLeft: 0 }}
          >
            <NoticeList />
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
          일정
        </TabPanel> */}
      </Paper>
    </Grid>
  );
}

// export default MainContainer;
export default TwoThirdNotice;
